import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMultiselectDeleteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 9,
	viewBox: "0 0 8 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .5,
		d: "M8 1.30571L7.19429 0.5L4 3.69429L0.805714 0.5L0 1.30571L3.19429 4.5L0 7.69429L0.805714 8.5L4 5.30571L7.19429 8.5L8 7.69429L4.80571 4.5L8 1.30571Z",
		fill: "#2B313A"
	})
});
export default SvgMultiselectDeleteIcon;
